import { render, staticRenderFns } from "./dutyperson.vue?vue&type=template&id=e8f1cd50&scoped=true&"
import script from "./dutyperson.vue?vue&type=script&lang=js&"
export * from "./dutyperson.vue?vue&type=script&lang=js&"
import style0 from "./dutyperson.vue?vue&type=style&index=0&id=e8f1cd50&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e8f1cd50",
  null
  
)

export default component.exports